import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";

export const SelectorButton = ({
  name,
  options,
  value,
  onChange,
  label,
  icon,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    handleClose();
  };

  const selectedOption = options.find((opt) => opt.value === value);

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        startIcon={icon}
        sx={{
          color: "#5e6c84",
          backgroundColor: "#f4f5f7",
          border: "1px solid #ddd",
          borderRadius: "3px",
          textTransform: "none",
          fontSize: "14px",
          padding: "6px 12px",
          lineHeight: "1.3",
          "&:hover": {
            backgroundColor: "#e4e6ea",
            border: "1px solid #ccc",
          },
        }}
      >
        {selectedOption ? selectedOption.label : label}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            minWidth: "200px",
            borderRadius: "3px",
            boxShadow:
              "0 8px 16px -4px rgba(9,30,66,.25), 0 0 0 1px rgba(9,30,66,.08)",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.value)}
            selected={option.value === value}
            sx={{
              fontSize: "14px",
              padding: "8px 12px",
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export const SelectorStyleButton = ({ name, onClick, label, icon }) => {
  return (
    <>
      <Button
        variant="outlined"
        onClick={onClick}
        startIcon={icon}
        sx={{
          color: "#5e6c84",
          backgroundColor: "#f4f5f7",
          border: "1px solid #ddd",
          borderRadius: "3px",
          textTransform: "none",
          fontSize: "14px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "#e4e6ea",
            border: "1px solid #ccc",
          },
        }}
      >
        {label}
      </Button>
    </>
  );
};
